import { getApiBaseUrl } from '@utils/apiBaseUrl'

export interface WorkshopSignupPayload {
  name: string
  workshopName: string
  email: string
  phone: string
  mechanicsRange: string
  heroVariant?: number
}

/** Mensagem mostrada ao utilizador após submeter o formulário (processamento em background). */
export const WORKSHOP_SIGNUP_SUCCESS_MESSAGE =
  'Recebemos o seu pedido. Se os dados forem válidos, receberá um email com as credenciais nos próximos minutos. Verifique também a pasta de spam. Em caso de dúvida, contacte equipa.fixdauto@gmail.com'

/**
 * Envia o registo com keepalive para o pedido continuar mesmo que o utilizador saia da página.
 * O backend responde 202 Accepted de imediato e processa em background.
 */
export async function submitWorkshopSignup(payload: WorkshopSignupPayload): Promise<void> {
  const url = `${getApiBaseUrl()}/public/workshop-signup`
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: true,
  })

  if (!response.ok) {
    throw new Error(`workshop-signup failed: ${response.status}`)
  }
}
